module.exports = __webpack_public_path__ + "img/POP-00008-2.6d9055d0.png";